import { memo } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Radio, RadioGroup } from '@ds';
import { AdminFormRow } from '@ui';
import { useTrialProgramsList } from '@/hooks/useTrialProgramsList';
import { OrganType } from '@/api/apis/case';
import { NewOcsConsoleForm } from '../types';

type OcsConsoleTrialProgramRowProps = {
  isReadOnly?: boolean;
};

export const OcsConsoleTrialProgramRow = memo(({ isReadOnly }: OcsConsoleTrialProgramRowProps) => {
  const { control } = useFormContext<NewOcsConsoleForm>();
  const organType = useWatch({ control, name: 'organType' });
  const { getTrialProgramByOrgan } = useTrialProgramsList();
  const trialProgram = getTrialProgramByOrgan(organType);

  if (!trialProgram || organType === OrganType.Kidney) return null;

  return (
    <AdminFormRow title={`${trialProgram.name} trial`} isRequired>
      <Controller
        name="trialProgramId"
        control={control}
        render={({ field: { value, ...field }, fieldState: { invalid, error } }) => (
          <RadioGroup
            className="gap-8"
            orientation="horizontal"
            value={value?.toString()}
            isInvalid={invalid}
            isDisabled={isReadOnly}
            errorMessage={error?.message}
            {...field}
          >
            <Radio className="w-[100px] max-w-none" key="true" value={trialProgram.id} size="lg">
              Yes
            </Radio>
            <Radio className="w-[100px] max-w-none" key="false" value="" size="lg">
              No
            </Radio>
          </RadioGroup>
        )}
      />
    </AdminFormRow>
  );
});

OcsConsoleTrialProgramRow.displayName = 'OcsConsoleTrialProgramRow';
